import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import TextField from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import IconBrandFacebook from "@midland-industries/Icons/IconBrandFacebook";
import IconBrandInstagram from "@midland-industries/Icons/IconBrandInstagram";
import IconBrandLinkedin from "@midland-industries/Icons/IconBrandLinkedin";
import IconBrandVimeo from "@midland-industries/Icons/IconBrandVimeo";
import IconBrandX from "@midland-industries/Icons/IconBrandX";
import IconBrandYoutube from "@midland-industries/Icons/IconBrandYoutube";
import { colors } from "@midland-industries/Styles/colors";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

const buttonCss = css`
    span {
        font-size: 15px;
    }
`;

const CustomFooter: FC = () => {
    const history = useHistory();
    const [disabled, setDisabled] = useState(true);
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (email && validateEmail(email)) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [email, disabled]);

    return (
        <div style={{ borderTop: `1px solid ${colors.border}` }}>
            <div style={{ maxWidth: 1112, margin: "0 auto", padding: "60px 0" }}>
                <Group justify="space-between" style={{ marginBottom: 48 }}>
                    <Group gap={24}>
                        <Clickable href="https://twitter.com/MidlandMetalMfg" target="_blank">
                            <Icon color={colors.textAccent} src={IconBrandX} />
                        </Clickable>
                        <Clickable href="https://www.facebook.com/MidlandMetalMfg/" target="_blank">
                            <Icon color={colors.textAccent} src={IconBrandFacebook} />
                        </Clickable>
                        <Clickable href="https://www.youtube.com/channel/UCxbA3eYGpqeWf-jYYX2-7Zg" target="_blank">
                            <Icon color={colors.textAccent} src={IconBrandYoutube} />
                        </Clickable>
                        <Clickable href="https://www.linkedin.com/company/midland-metal-mfg/" target="_blank">
                            <Icon color={colors.textAccent} src={IconBrandLinkedin} />
                        </Clickable>
                        <Clickable href="https://www.instagram.com/midlandmetalmfg/?hl=en" target="_blank">
                            <Icon color={colors.textAccent} src={IconBrandInstagram} />
                        </Clickable>
                        <Clickable href="https://vimeo.com/midlandindustries" target="_blank">
                            <Icon color={colors.textAccent} src={IconBrandVimeo} />
                        </Clickable>
                    </Group>
                    <Typography color={colors.textAccent}>&copy; Midland Industries, 2025</Typography>
                </Group>
                <Group gap={60}>
                    <Stack>
                        <Typography
                            transform="uppercase"
                            weight={700}
                            color={colors.textAccent}
                            style={{ marginBottom: 9 }}
                        >
                            Information
                        </Typography>
                        <Link href="/about-us" style={{ padding: "6px 0" }}>
                            About us
                        </Link>
                        <Link href="/about-us/Careers" style={{ padding: "6px 0" }}>
                            Careers
                        </Link>
                        <Link href="/delivery-information" style={{ padding: "6px 0" }}>
                            Delivery Information
                        </Link>
                        <Link href="/terms-and-conditions" style={{ padding: "6px 0" }}>
                            Terms & Conditions
                        </Link>
                    </Stack>
                    <Stack>
                        <Typography
                            transform="uppercase"
                            weight={700}
                            color={colors.textAccent}
                            style={{ marginBottom: 9 }}
                        >
                            My Account
                        </Typography>
                        <Link href="/my-account/Orders" style={{ padding: "6px 0" }}>
                            Orders
                        </Link>
                        <Link href="/my-account/Invoices" style={{ padding: "6px 0" }}>
                            Invoices
                        </Link>
                        <div style={{ height: 1, background: colors.border, margin: "6px 0" }} />
                        <Link href="/my-account/custom-catalog" style={{ padding: "6px 0" }}>
                            Custom Catalog Ordering
                        </Link>
                        <Link href="/my-account/price-sheets" style={{ padding: "6px 0" }}>
                            Price Sheets
                        </Link>
                        <Link href="/my-account/bin-labels" style={{ padding: "6px 0" }}>
                            Bin Labels on Demand
                        </Link>
                        <div style={{ height: 1, background: colors.border, margin: "6px 0" }} />
                        <Link href="/my-account/change-customer" style={{ padding: "6px 0" }}>
                            Change Customer
                        </Link>
                        <Link href="/my-account/Addresses" style={{ padding: "6px 0" }}>
                            Addresses
                        </Link>
                        <Link href="/my-account/saved-payments" style={{ padding: "6px 0" }}>
                            Saved Payments
                        </Link>
                        <div style={{ height: 1, background: colors.border, margin: "6px 0" }} />
                        <Link href="/my-account/my-lists" style={{ padding: "6px 0" }}>
                            My Lists
                        </Link>
                        <Link href="/my-account/my-part-numbers" style={{ padding: "6px 0" }}>
                            My Part Numbers
                        </Link>
                        <Link href="/my-account/account-settings" style={{ padding: "6px 0" }}>
                            Account Settings
                        </Link>
                    </Stack>
                    <Stack>
                        <Typography
                            transform="uppercase"
                            weight={700}
                            color={colors.textAccent}
                            style={{ marginBottom: 9 }}
                        >
                            Customer Service
                        </Typography>
                        <Link href="/Contact" style={{ padding: "6px 0" }}>
                            Contact Us
                        </Link>
                        <Link href="/my-account/Orders" style={{ padding: "6px 0" }}>
                            Returns
                        </Link>
                    </Stack>
                    <Stack>
                        <Typography
                            transform="uppercase"
                            weight={700}
                            color={colors.textAccent}
                            style={{ marginBottom: 9 }}
                        >
                            Extras
                        </Typography>
                        <Link href="/FAQ" style={{ padding: "6px 0" }}>
                            FAQ
                        </Link>
                        <Link href="/Downloads/knowledge-bank" style={{ padding: "6px 0" }}>
                            Knowledge Bank
                        </Link>
                        <Link href="https://www.p65warnings.ca.gov/" target="_blank" style={{ padding: "6px 0" }}>
                            CA Prop. 65 Info
                        </Link>
                    </Stack>
                    <Stack>
                        <Typography
                            transform="uppercase"
                            weight={700}
                            color={colors.textAccent}
                            style={{ marginBottom: 9 }}
                        >
                            Stay Informed
                        </Typography>
                        <Typography style={{ maxWidth: 311 }} color={colors.textAccent} lineHeight="24px">
                            Stay up to date with Midland Industries. Sign up for Midland’s Newsletter and stay up to
                            date on all our latest products and pricing.
                        </Typography>
                        <TextField placeholder="Email" value={email} onChange={e => setEmail(e.currentTarget.value)} />
                        <Button
                            disabled={disabled}
                            onClick={() => history.push("/Contact/Subscribe")}
                            style={{ minHeight: 30, marginTop: 6 }}
                            css={buttonCss}
                            mergeCss
                        >
                            Sign Up
                        </Button>
                    </Stack>
                </Group>
            </div>
        </div>
    );
};

const customFooter: WidgetModule = {
    component: CustomFooter,
    definition: {
        displayName: "Custom Footer",
        group: "Footer",
    },
};

export default customFooter;
